<div class="feedCardProfile" *ngIf="cardType !== 'recommended-profiles'">
  <vc-ref
    [isBlock]="true"
    class="profileDesc__wrap"
    i18n-resource="@@PRODUCT.DETAILS.SELLER_PROFILE_LINK"
    [resource]="'/membres/profil-' + profile.describes.url + '.shtml'"
    (click)="
      seeMember.emit(
        !profile.isFollowed && feedType === 'default'
          ? {emitter: 'link', profileId: profile.describes.id, trackingKey: profile.trackingKey}
          : {emitter: 'link'}
      )
    "
  >
    <div class="profileDesc">
      <img
        class="profileDesc__pic"
        *ngIf="profile.describes.picture !== ''"
        [src]="imgixPath + '/profil/' + profile.describes.picture"
        alt=""
      />
      <img
        class="profileDesc__pic"
        *ngIf="profile.describes.picture === ''"
        [src]="imgixPath + '/profil/missing_avatar.gif'"
        alt=""
      />
      <div class="profileDesc__info">
        <p
          *ngIf="!profile.isFollowed && feedType === 'default'"
          class="profileDesc__info__sugg vc-text-s"
          i18n="@@FEED.CARD.PROFILE.SUGG_PROFILE"
        >
          Suggestion
        </p>
        <p class="profileDesc__info__name vc-text-m">
          {{ profile.describes.name }}
        </p>
        <div *ngIf="profile.isFollowed" class="profileDesc__info__loc vc-text-s">
          <vc-sprite-icons class="profileDesc__info__loc__icon" name="pin-full"></vc-sprite-icons>
          {{ profile.describes.location }}
        </div>
      </div>
    </div>
  </vc-ref>

  <vc-ref
    [anchor]="false"
    [resource]="'/membres/profil-' + profile.describes.url + '.shtml'"
    *ngIf="justBeenFollowed && profile.isFollowed"
    class="profileDesc__cta vc-text-xs vc-btn vc-btn--secondary vc-btn--small"
    i18n="@@FEED.CARD.PROFILE.FOLLOWING"
    (click)="seeMember.emit({emitter: 'button'})"
  >
    Following
  </vc-ref>

  <vc-follow-button
    *ngIf="!profile.isFollowed"
    class="profileDesc__cta vc-text-xs vc-btn vc-btn--social vc-btn--small"
    i18n-resource="@@FEED.CARD.PROFILE.FOLLOW"
    [userToFollow]="profile.describes.id"
    [isFollow]="profile.isFollowed"
    [stopPropagation]="false"
    (click)="toFollow()"
  ></vc-follow-button>
</div>
